import { useEffect, useMemo, useState } from 'react';

export function useProgressBarState(isLoading: boolean) {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [progressBarVisible, setProgressBarVisible] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setProgressBarVisible(true);
    }
    const timer = setInterval(() => {
      setLoadingProgress((oldProgress) => {
        if (!isLoading) {
          clearInterval(timer);
          return 100;
        }
        if (oldProgress === 90) {
          return 90;
        }
        const diff = (Math.random() * 10) / 2;
        return Math.min(oldProgress + diff, 90);
      });
    }, 500);

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isLoading]);

  useEffect(() => {
    if (loadingProgress === 100) {
      setTimeout(() => {
        setProgressBarVisible(false);
        setLoadingProgress(0);
      }, 10);
    }
  }, [loadingProgress]);

  return useMemo(
    () => ({ loadingProgress, progressBarVisible }),
    [loadingProgress, progressBarVisible]
  );
}
